import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useMemo } from 'react'
import decodeJwt from 'jwt-decode'

export const useGetOrgId = (): string => {
  const { token } = useAuthState()
  return useMemo(() => {
    if (token) {
      const decodedToken = decodeJwt<{ tenantId: string }>(token ?? '')
      return decodedToken?.tenantId
    } else {
      return ''
    }
  }, [token])
}
